import {InputController} from "./InputController";

declare const toastui: any;

/** Markdown Editor */
export class MarkdownViewerController extends InputController {

  private editor: any;

  public static $inject = ["$element", "$scope", "$attrs", "$timeout"];

  /**
   * Creates a new MarkdownEditorController
   * @ignore
   */
  constructor(private $element: JQLite, private $scope: angular.IScope, private $attrs: angular.IAttributes, private $timeout: angular.ITimeoutService) {
    super();
  }

  /** Init */
  public $onInit = () => {
    super.$onInit();
    this.editor = toastui.Editor.factory({
      el: this.$element[0].querySelector("#viewer"),
      viewer: true,
      height: "500px",
      initialEditType: "wysiwyg",
      previewStyle: "vertical"
    });
    this.$scope.$watch(this.$attrs.ngModel, (newValue) => {
        this.changeValue(newValue as any);
    });
  };

  /** Value initialization */
  public onInitValue(){
    this.changeValue(this.value);
  }

  /** New value */
  public changeValue(newValue: string) {
    this.editor.setMarkdown(newValue);
    this.$timeout();
  }
}

